import { createContext, useContext, useEffect } from 'react';

// Below 768px the sidebar (and its search boxes) isn't shown at all — a page
// with its own search feature (EntryLibrary, Dancers) registers it here so
// it renders in the mobile title bar instead, where it can't scroll out of
// reach. Desktop pages just never register (or register null) and keep
// their search inline as before. Setter-only context: the page's search
// input/state stays owned by the page itself, this only relays the render
// config up to MobileTopBar.
//
// Lives in its own file (rather than TeacherApp.js) so page components can
// import the hook without creating a circular dependency on TeacherApp.js,
// which itself imports those page components.
export const TitleBarSearchContext = createContext(() => {});

// config: null to clear, or { placeholder, value, onChange }.
export function useTitleBarSearch(config) {
  const setConfig = useContext(TitleBarSearchContext);
  useEffect(() => {
    setConfig(config);
    return () => setConfig(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config?.placeholder, config?.value, config?.onChange]);
}
